import { parsePlaceholder } from '../utils';
import { INTERPOLATION_REGEX, LOWERCASE_REGEX } from '../../constants';
function parseLowercase(_ref) {
  var source = _ref.source,
    data = _ref.data;
  if (typeof data !== 'string') return data;
  var hasLowercase = data.includes(':lowercase');
  if (!hasLowercase) return data;
  var placeholder = data.replace(LOWERCASE_REGEX, '');
  var placeholders = placeholder.match(INTERPOLATION_REGEX);
  var parsedPlaceholder = parsePlaceholder(placeholders, placeholder, source);
  if (typeof parsedPlaceholder !== 'string') return parsedPlaceholder;
  return parsedPlaceholder.toLowerCase();
}
export default parseLowercase;